import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'
import { selectUserSubscriptionInfo } from 'root-redux/selects/user'

import { formatPrice } from 'helpers/formatPrice'

import { getBillingCycleKey } from 'modules/unsubscribe/helpers'

import { SubscriptionContainer as Container } from 'common-styles'
import { AppName } from 'root-constants'

import { StyledSubscriptions as S } from '../../Subscriptions.styles'
import { FREE_EXTRA_PROGRAMS, TSubscriptionDetailsProps } from '../../constants'

export const TrialSubscriptionDetails: React.FC<TSubscriptionDetailsProps> = ({
  extra,
  secondarySubscription,
}: TSubscriptionDetailsProps) => {
  const { t } = useTranslation()
  const subscriptionInfo = useSelector(selectUserSubscriptionInfo)
  const appName = useSelector(selectAppName)

  const userSubscriptionInfo = secondarySubscription || subscriptionInfo

  if (!userSubscriptionInfo) {
    return null
  }

  const trialPrice = extra
    ? extra.trialPrice
    : userSubscriptionInfo.trialSubAmount || userSubscriptionInfo.trialPrice

  const trialDays = extra?.trialDaysCount || userSubscriptionInfo.trialDaysCount

  const isFreeExtraProgram =
    extra &&
    (FREE_EXTRA_PROGRAMS.includes(extra.productId) ||
      (appName === AppName.FITME && !trialPrice && !!trialDays))

  return (
    <>
      <S.SubscriptionRow>
        <span>
          {t(
            extra
              ? 'subscription.extraProgram.startDate'
              : 'subscription.startDate',
          )}
        </span>
        <Container.InfoValue>
          {userSubscriptionInfo.trialStartDate ||
            userSubscriptionInfo.startDate}
        </Container.InfoValue>
      </S.SubscriptionRow>
      {!!trialDays && (
        <S.SubscriptionRow>
          <span>{t('subscription.trialPeriod')}</span>
          <Container.InfoValue>
            {t(
              `subscription.trialBillingPeriods.${getBillingCycleKey(
                userSubscriptionInfo.trialDaysCount,
              )}`,
              {
                count: userSubscriptionInfo.trialDaysCount,
              },
            )}
          </Container.InfoValue>
        </S.SubscriptionRow>
      )}
      {(!!trialPrice || isFreeExtraProgram) && (
        <S.SubscriptionRow>
          <span>{t('subscription.trialPrice')}</span>
          <Container.InfoValue>
            {t('subscription.priceAmount', {
              currency: userSubscriptionInfo.currencySymbol,
              amount: formatPrice(trialPrice, userSubscriptionInfo.currency),
            })}
          </Container.InfoValue>
        </S.SubscriptionRow>
      )}
    </>
  )
}
